import { policy } from './policies'
import { euro } from '../core/format/currency'
import type { Treatment, TreatmentCategory } from '../core/types/catalog'

/** De vaste volgorde van de categorieën (salonpagina en beheer). */
export const treatmentCategories: TreatmentCategory[] = ['Anti-ageing', 'Huidverbetering', 'Ontspanning', 'Losse applicaties']

/** Prijzen en duur als getallen; de opmaak ("75 min · € 99") zit in utils/catalog.ts. */
export const treatments: Treatment[] = [
  {
    slug: 'cosmic-botox',
    name: 'Cosmic Botox',
    tagline: 'Lift zonder prikken of snijden',
    description:
      'Geen botuline, maar bindweefselmassage, ontspanningsmassage en energy work in één. De gezichtsspieren ontspannen, de doorbloeding komt op gang en het zelfhelend vermogen wordt geactiveerd. Helpt bij hangende oogleden, verslapping, vermoeide ogen en fijne lijntjes. Resultaat: subtiel vollere lippen en strakkere contouren.',
    durationMinutes: 75,
    price: null,
    kuur: { sessions: 3, price: 450 },
    focus: ['Verslapping', 'Vermoeide ogen', 'Fijne lijntjes'],
    category: 'Anti-ageing',
    bindweefsel: true,
    signature: true,
    // Tijdelijk sfeerbeeld tot de fotoshoot (docs/BEELDEN.md, S2).
    media: {
      image: 'https://cdn.magicpatterns.com/patterns/generated-images/defd54fa-b855-47e6-998a-0f04d3a60010.jpg',
      alt: 'Vingertoppen die de huid bij de slaap zacht optillen bij een cliënte met gesloten ogen',
      focus: { x: 60, y: 45 },
    },
  },
  {
    slug: 'goddess-lift',
    name: 'Goddess Lift',
    tagline: 'Protocell peel-off masker met appelstamcellen',
    description:
      'De ultieme relax-ervaring. Een masker met stamcellen van Zwitserse biologische appels (appels die niet rimpelen) wordt met peptiden je huid ingewerkt. Een glow waar je dagenlang van geniet. Inclusief bindweefselmassage.',
    durationMinutes: 80,
    price: 135,
    kuur: { sessions: 6, price: 635 },
    focus: ['Glow', 'Anti-ageing', 'Diepe ontspanning'],
    category: 'Anti-ageing',
    bindweefsel: true,
    signature: true,
    media: {
      image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6db1546-82f9-4b1c-ae08-5814adccd04c.jpg',
      alt: 'Een zacht peel-off masker wordt met een kwastje op wang en kaak aangebracht',
    },
  },
  {
    slug: 'restoration-of-juvenation',
    name: 'Restoration of Juvenation',
    tagline: 'Twee uur: huidverzorging én energetische healing',
    description:
      'Believe the hype. Een basisbehandeling gecombineerd met zestig minuten energetische healing en facelift. Door het weefsel onder druk te zetten komt hyaluronzuur vrij, worden collageen en elastine geactiveerd en voeren we afvalstoffen af. De gymles voor je huid, in de meest ontspannen vorm.',
    durationMinutes: 120,
    price: 180,
    focus: ['Anti-ageing', 'Energetisch werk', 'Volledige reset'],
    category: 'Anti-ageing',
    bindweefsel: true,
    signature: true,
  },
  {
    slug: 'get-the-red-out',
    name: 'Get the Red Out',
    tagline: 'Voor roodheid en ontstekinkjes',
    description:
      'Kalmeert een huid die rood aanloopt en snel ontstoken raakt. Inclusief bindweefselmassage en, als je dat wilt, een applicatie zoals het verven of suikeren van bovenlip of wenkbrauwen.',
    durationMinutes: 75,
    price: 99,
    focus: ['Roodheid', 'Ontstekingen', 'Gevoelige huid'],
    category: 'Huidverbetering',
    bindweefsel: true,
  },
  {
    slug: 'vitamine-c-behandeling',
    name: 'Vitamine C Behandeling',
    tagline: 'Gericht op pigmentatie',
    description:
      'Werkt aan een egalere teint bij pigmentvlekken, met de stabiele stay-C formule van emerginC. Inclusief bindweefselmassage en ruimte voor extra applicaties.',
    durationMinutes: 75,
    price: 99,
    kuur: { sessions: 6, price: 485 },
    focus: ['Pigmentatie', 'Egale teint', 'Hormonale huid'],
    category: 'Huidverbetering',
    bindweefsel: true,
  },
  {
    slug: 'ibiza-behandeling',
    name: 'Ibiza Special',
    tagline: 'Alsof je een vakantie hebt gehad',
    description:
      'Gun je jezelf even tijd. Zestig minuten huidverzorging en ontspanning met een heerlijke gezichtsmassage. De ultieme basisbehandeling wanneer je op zoek bent naar een quick fix in ontspanning.',
    durationMinutes: 60,
    price: 85,
    focus: ['Ontspanning', 'Alle huidtypes', 'Kennismaking'],
    category: 'Ontspanning',
    signature: true,
  },
  {
    slug: 'bindweefselmassage-los',
    name: 'Bindweefselmassage',
    tagline: 'Losse applicatie van 25 minuten',
    description:
      'De fitnessoefening voor je huid, ook los te boeken. Aan te raden in kuurvorm: om de drie weken een afspraak.',
    durationMinutes: 25,
    price: 45,
    focus: ['Anti-ageing', 'Doffe huid', 'Doorbloeding'],
    category: 'Losse applicaties',
    bindweefsel: true,
  },
  {
    slug: 'persian-delight',
    name: 'Persian Delight',
    tagline: 'Wimpers & wenkbrauwen verven en epileren',
    description:
      'Een scherpe blik zonder make-up. Verven en in model brengen van wimpers en wenkbrauwen.',
    durationMinutes: 30,
    price: 45,
    focus: ['Wenkbrauwen', 'Wimpers'],
    category: 'Losse applicaties',
  },
  {
    slug: policy.consult.slug,
    name: policy.consult.name,
    tagline: 'Online huidconsult · verrekend bij je bestelling',
    description: `Laat zien wat er in je badkamerkastje staat. Samen kijken we wat je huid nodig heeft en wat weg mag, en je plan staat daarna in Mijn omgeving. Bestel je daarna voor ${euro(policy.consult.creditFrom)} of meer, dan verrekenen we het consult volledig.`,
    durationMinutes: policy.consult.minutes,
    price: policy.consult.price,
    focus: ['Advies', 'Thuisroutine'],
    category: 'Losse applicaties',
    online: true,
  },
]

